import React, { ReactNode, useContext, useEffect, useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";

import { rolesPossuemPermissao, useAuth } from "shared/hooks/auth";
import { listarUsuariosTroca } from "services/auth";
import { urlLogin } from "services/axios/api";
import { paginaEntradaMof } from "shared/helpers/paginaEntrada";

import { Dropdown, Form, Nav, NavDropdown, Navbar } from "react-bootstrap";

// import { IFiltro } from "../../common/interfaces/produtos.interfaces";
// import { ProdutoContext } from "../../contexts/produtos/produtosContext";
// import { EsquadriaProvider } from "../../pages/Catalogos/hook";
import SelectComponent, { Items } from "components/Select";
import { FormProvider, useForm } from "react-hook-form";
import history from "shared/helpers/histoy";
import LogoMof from "assets/images/logoMof";
import { AppBar, Box, Grid, Toolbar } from "@mui/material";
import { SidebarProvider } from "contexts/sidebarContext";
import ReactSelect from "react-select";
import { getErrorsByApi } from "shared/helpers/getErrorsByApi";
import configs, { dashboardDisponivel } from "Config";
import { TagDashboard, NavMenuItem } from "components/TagDashboard";
// Plano de 07/09/2026 (Frente 1): o menu lê a PRÓPRIA empresa/usuário pelos endpoints
// MinhaEmpresa/*, que só exigem autenticação. Os endpoints por id (Empresa/*) exigem a tela
// Configuracao — usuário sem ela recebia 403 e o menu ficava só com Home/Tabelas/Ações.
import { getMeusCadastrosN2 } from "services/modules/cadastrosN2";
import { getMeuUsuario } from "services/modules/empresas/usuarios";
import { getMinhaEmpresa } from "services/modules/empresas";
import { jwtDecode } from "jwt-decode";
import { ModalExportarDados } from "pages/QuadroTarefas/components/ModalExportarDados";
import { obterTiposPermitidos } from "pages/ProdutosN1/services/materiaisN1";
import {
  ABA_APLICABILIDADES,
  ABA_TABELAS_PRECO,
  TELAS_APLICABILIDADE,
  TELAS_TABELA_PRECO,
  empresaTemRecurso,
  temAcessoRecurso,
  usuarioTemAba,
} from "shared/helpers/acessoRecursos";
import { AcessoRecursosContext } from "contexts/acessoRecursosContext";

interface PrivateProviderProps {
  children?: React.ReactNode;
}

// Plano de 07/10/2026 (B1.4): rota privada sem sessão vai para o login, sem montar a página.
export const Private = ({ children }: PrivateProviderProps) => {
  const { signed } = useAuth();
  if (!signed) return <Navigate to="/login" replace />;
  return <PrivateConteudo>{children}</PrivateConteudo>;
};

const PrivateConteudo = ({ children }: PrivateProviderProps) => {
  const { control, ...methods } = useForm({
    mode: "onBlur",
  });
  //Contexts
  const { user, signOut, signInChange, havePermission } = useAuth();
  const [users, setUsers] = useState([]);
  // Reporte do PO de 03/09: sem aviso, o primeiro segundo da troca de usuário parece que nada
  // aconteceu. Desde o plano de 07/10/2026 a troca não passa mais pelo legado (recarga da página).
  const [trocandoUsuario, setTrocandoUsuario] = useState(false);
  
  // Estados para controle de acesso às funcionalidades de Tipologias
  const [acessoSolicitacoes, setAcessoSolicitacoes] = useState(false);
  const [acessoCadastroTipologias, setAcessoCadastroTipologias] = useState(false);
  const [temAcessoAbaN2, setTemAcessoAbaN2] = useState(false);
  const [empresaTemRecursoN2, setEmpresaTemRecursoN2] = useState(false);

  // Estados para controle de acesso às funcionalidades de Tarefas
  const [empresaTemRecursoTarefas, setEmpresaTemRecursoTarefas] = useState(false);
  const [temAcessoAbaTarefas, setTemAcessoAbaTarefas] = useState(false);

  // Modal "Exportar Dados" do menu Tarefas
  const [modalExportarTarefasOpen, setModalExportarTarefasOpen] = useState(false);

  // Estados para controle de acesso às funcionalidades de Cadastros N1 (Produtos)
  const [empresaTemRecursoN1, setEmpresaTemRecursoN1] = useState(false);
  const [temAcessoAbaN1, setTemAcessoAbaN1] = useState(false);
  // FASE 05 — Ajustes 25/08 (F05A-P1): o ícone "Acabamentos" só aparece para a empresa que
  // tem Acabamentos liberado em Gerência > Empresa > Cadastros N1. A fonte é a MESMA que a
  // página usa (ObterTiposPermitidos), para menu e conteúdo não divergirem.
  const [temAcabamentosLiberados, setTemAcabamentosLiberados] = useState(false);

  // Plano de 07/10/2026 (Frente 1): Aplicabilidades e Tabelas de Preços seguem o recurso da empresa
  // + a aba do usuário + a tela do recurso no token (shared/helpers/acessoRecursos.ts).
  const [empresaTemRecursoAplicabilidades, setEmpresaTemRecursoAplicabilidades] = useState(false);
  const [temAcessoAbaAplicabilidades, setTemAcessoAbaAplicabilidades] = useState(false);
  const [empresaTemRecursoTabelaPreco, setEmpresaTemRecursoTabelaPreco] = useState(false);
  const [temAcessoAbaTabelaPreco, setTemAcessoAbaTabelaPreco] = useState(false);
  const [acessoRecursosCarregado, setAcessoRecursosCarregado] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (havePermission(["Master"])) {
          // Plano de 07/10/2026 (B1.5): lista do backend novo (só Masters ativos), não do legado.
          const data: any = await listarUsuariosTroca();

          setUsers(data);
        }
      } catch (error: any) {
        getErrorsByApi(
          error,
          "Tivemos problema internos ao buscar esse Usuario"
        );
      }
    };

    fetchData();
    // Depende de hashSession: na entrada via SSO o `user` hidrata de forma
    // assíncrona depois da montagem; sem esta dependência o efeito rodava 1x
    // com havePermission("Master") ainda falso e o seletor nunca aparecia.
  }, [user?.hashSession]);

  // Busca configurações de acesso às Tipologias da empresa e abas do usuário
  // Depende de idEmpresa E hashSession para garantir atualização após troca de usuário
  useEffect(() => {
    const fetchAcessoTipologias = async () => {
      if (user?.idEmpresa) {
        // Revisão de 08/10/2026: cada leitura tem o seu try/catch — a falha de uma (ex.: tipos
        // permitidos ou Cadastros N2) não pode impedir a leitura das abas do usuário, senão
        // Aplicabilidades/Tabelas de Preços aparecem como "Recurso não liberado" sem motivo.
        // Falha tem que aparecer como erro, com o status HTTP (o 403 de 06/09 passou meses escondido num warn).
        const registrarFalha = (leitura: string, error: any) => {
          console.error(
            `Erro ao buscar ${leitura} para o menu (status ` +
              (error?.response?.status ?? error?.status ?? "?") +
              "):",
            error
          );
        };

        try {
          // Obter idUsuario do token JWT
          const token = sessionStorage.getItem("@MOF:token");
          let idUsuario = 0;
          if (token) {
            const decoded: any = jwtDecode(token);
            idUsuario = decoded.IdUsuario ? parseInt(decoded.IdUsuario) : 0;
          }

          // 1. Verificar se a empresa tem o RECURSO "Cadastros N2" habilitado
          // Pode estar no perfil da empresa OU como recurso adicional
          let abasPerfil: any[] = [];
          let recursosAdicionais: any[] = [];
          try {
            const empresaResponse = await getMinhaEmpresa();
            abasPerfil = empresaResponse?.data?.abasUtilizadasPerfil || [];
            recursosAdicionais = empresaResponse?.data?.abasUtilizadasRecursosAdicionais || [];
          } catch (error: any) {
            registrarFalha("os recursos da empresa", error);
          }
          const temRecursoN2 = abasPerfil.some((aba: any) => aba.id === 9) || recursosAdicionais.some((recurso: any) => recurso.id === 9);
          setEmpresaTemRecursoN2(temRecursoN2);

          const temRecursoTarefas = abasPerfil.some((aba: any) => aba.id === 10) || recursosAdicionais.some((recurso: any) => recurso.id === 10);
          setEmpresaTemRecursoTarefas(temRecursoTarefas);

          const temRecursoN1 = abasPerfil.some((aba: any) => aba.id === 2) || recursosAdicionais.some((recurso: any) => recurso.id === 2);
          setEmpresaTemRecursoN1(temRecursoN1);

          setEmpresaTemRecursoAplicabilidades(empresaTemRecurso(abasPerfil, recursosAdicionais, ABA_APLICABILIDADES));
          setEmpresaTemRecursoTabelaPreco(empresaTemRecurso(abasPerfil, recursosAdicionais, ABA_TABELAS_PRECO));

          // F05A-P1: só consulta os tipos liberados se a empresa tem o recurso N1 — evita
          // uma chamada inútil para quem nem enxerga Cadastros N1.
          if (temRecursoN1 && user?.idEmpresa) {
            try {
              const tipos = await obterTiposPermitidos(user.idEmpresa);
              setTemAcabamentosLiberados(
                (tipos?.tipos ?? []).some((t) => t.tipoMaterial === "acabamentos")
              );
            } catch (error: any) {
              setTemAcabamentosLiberados(false);
              registrarFalha("os tipos de material liberados", error);
            }
          } else {
            setTemAcabamentosLiberados(false);
          }

          // Se a empresa não tem o recurso N2, limpar estados de Tipologias
          if (!temRecursoN2) {
            setAcessoSolicitacoes(false);
            setAcessoCadastroTipologias(false);
            setTemAcessoAbaN2(false);
          } else {
            // 2. Buscar configurações de Cadastros N2 da empresa
            try {
              const cadastrosN2 = await getMeusCadastrosN2();
              if (cadastrosN2) {
                setAcessoSolicitacoes(cadastrosN2.acessoSolicitacoesTipologias);
                setAcessoCadastroTipologias(cadastrosN2.acessoCadastroTipologiasLiberadas);
              }
            } catch (error: any) {
              registrarFalha("as configurações de Cadastros N2", error);
            }
          }

          // 3. Buscar abas do usuário atual (aba 9 = Cadastros N2, aba 10 = Tarefas)
          if (idUsuario > 0) {
            try {
              const usuarioResponse = await getMeuUsuario();
              // abasUtilizadas é um array com { id, nome, disponivel }
              const abasUsuario = usuarioResponse?.data?.abasUtilizadas || [];
              // Verificar se o usuário tem a aba "Cadastros N1" (ID = 2)
              setTemAcessoAbaN1(abasUsuario.some((aba: any) => aba.id === 2));
              // Verificar se o usuário tem a aba "Cadastros N2" (ID = 9)
              setTemAcessoAbaN2(abasUsuario.some((aba: any) => aba.id === 9));
              // Verificar se o usuário tem a aba "Tarefas" (ID = 10)
              setTemAcessoAbaTarefas(abasUsuario.some((aba: any) => aba.id === 10));
              setTemAcessoAbaAplicabilidades(usuarioTemAba(abasUsuario, ABA_APLICABILIDADES));
              setTemAcessoAbaTabelaPreco(usuarioTemAba(abasUsuario, ABA_TABELAS_PRECO));
            } catch (error: any) {
              registrarFalha("as abas do usuário", error);
            }
          }
        } catch (error: any) {
          registrarFalha("os recursos da empresa/usuário", error);
        } finally {
          setAcessoRecursosCarregado(true);
        }
      } else {
        // Limpar estados se não houver usuário ou empresa
        setEmpresaTemRecursoAplicabilidades(false);
        setTemAcessoAbaAplicabilidades(false);
        setEmpresaTemRecursoTabelaPreco(false);
        setTemAcessoAbaTabelaPreco(false);
        setAcessoRecursosCarregado(true);
        setEmpresaTemRecursoN1(false);
        setTemAcessoAbaN1(false);
        setEmpresaTemRecursoN2(false);
        setAcessoSolicitacoes(false);
        setAcessoCadastroTipologias(false);
        setTemAcessoAbaN2(false);
        setEmpresaTemRecursoTarefas(false);
        setTemAcessoAbaTarefas(false);
      }
    };
    
    fetchAcessoTipologias();
  }, [user?.idEmpresa, user?.hashSession]);

  const handleChangeLogin = async ({ value }: any) => {
    // O aviso sobe antes da chamada e só desce em caso de erro: no caminho feliz quem tira a tela
    // é a recarga completa na página de entrada do novo usuário (menu e efeitos releem a sessão).
    setTrocandoUsuario(true);

    try {
      const novoUsuario = await signInChange({ idUsuario: value });
      const paginaEntrada = paginaEntradaMof(
        (permissoes) => rolesPossuemPermissao(novoUsuario.role, permissoes),
        dashboardDisponivel()
      );
      const base = (configs.REACT_APP_BASENAME ?? "").replace(/\/+$/, "");
      window.location.assign(`${base}${paginaEntrada}`);
    } catch (error: any) {
      setTrocandoUsuario(false);
      getErrorsByApi(error, "Não foi possível trocar de usuário");
    }
  };

  const navGerencia = <i className="fas fa-cogs mr-1">Gerência</i>;

  // Plano de 07/10/2026 (Frente 1): mesma regra no menu e na guarda de rota (ExigeRecurso).
  const acessoRecursos = {
    aplicabilidades: temAcessoRecurso(empresaTemRecursoAplicabilidades, temAcessoAbaAplicabilidades, havePermission, TELAS_APLICABILIDADE),
    tabelasPreco: temAcessoRecurso(empresaTemRecursoTabelaPreco, temAcessoAbaTabelaPreco, havePermission, TELAS_TABELA_PRECO),
    carregado: acessoRecursosCarregado,
  };

  // const produtoContext = useContext(ProdutoContext);

  // const filtro = produtoContext.filtro;
  const location = useLocation();

  const queryString = require("querystring");
  const [modoEdicao, setModoEdicao] = useState(false);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const modoEdicao = await api.get("");
  //     setModoEdicao(modoEdicao.data);
  //   };

  //   fetchData();
  // }, []);

  // async function handleFiltro(filtro: IFiltro, modoEdicao: boolean) {
  //   replace(`/produtos?${queryString.stringify(filtro)}`);
  // }

  const menuItemStyle = { display: 'flex', flexDirection: 'column' as const, alignItems: 'center', textAlign: 'center' as const };
  const iconStyle = { fontSize: '18px', marginBottom: '4px' };
  const labelStyle = { fontSize: '12px', fontWeight: 500 };

  const navProdutos = (
    <div style={menuItemStyle}>
      <i className="fas fa-cubes" style={iconStyle}></i>
      <span style={labelStyle}>Produtos</span>
    </div>
  );

  // FASE 05 — Ajustes 25/08 (F05A-P1): ícone da página nova de Acabamentos.
  const navAcabamentos = (
    <div style={menuItemStyle}>
      <i className="fas fa-fill-drip" style={iconStyle}></i>
      <span style={labelStyle}>Acabamentos</span>
    </div>
  );

  const navLiberacoes = (
    <div style={menuItemStyle}>
      <i className="fas fa-clipboard-check" style={iconStyle}></i>
      <span style={labelStyle}>Liberações</span>
    </div>
  );

  const navAplicabilidades = (
    <div style={menuItemStyle}>
      <i className="fas fa-link" style={iconStyle}></i>
      <span style={labelStyle}>Aplicabilidades</span>
    </div>
  );

  // useEffect(() => {
  //   handleFiltro(filtro, modoEdicao);
  // }, [filtro, modoEdicao]);

  return (
    <SidebarProvider>
      <>
        {/* Tela única de transição da troca de usuário (reporte do PO de 03/09): cobre o trajeto
            inteiro, do clique no seletor até a recarga na página de entrada do novo usuário. */}
        {trocandoUsuario && (
          <div
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              zIndex: 2000,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#fff",
            }}
          >
            <LogoMof style={{ width: 140, height: 40 }} />
            <span style={{ marginTop: 16, color: "#555" }}>
              Trocando de usuário...
            </span>
          </div>
        )}
        <header className="navbar navbar-expand-md pb-2">
          <div className="container-xl px-3">
            <a className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pr-0 pr-md-4">
              <LogoMof
                style={{
                  width: 110,
                  height: 32,
                }}
                className="navbar-brand-image"
              />
            </a>
            <div className="navbar-nav flex-row order-md-last user">
              <div className="nav-item selectUsuario mr-3">
                {users?.length != 0 && (
                  <Form style={{ zIndex: 1000 }}>
                    <ReactSelect
                      className="text-left"
                      name="usuarios"
                      placeholder="Selecione um usuário..."
                      options={users}
                      onChange={(e): any => handleChangeLogin(e)}
                    ></ReactSelect>
                  </Form>
                )}
              </div>
              <div className="nav-item">
                <Dropdown>
                  <Dropdown.Toggle variant="none" className="mr-3">
                    <i className="far fa-user icon"></i>
                    {user?.nome}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Link className="dropdown-item" to="/minhaConta">
                      Minha Conta
                    </Link>
                    <Dropdown.Item
                      onClick={() => {
                        // Plano de 07/10/2026 (B1.6): Sair encerra a sessão aqui mesmo, sem passar pelo legado.
                        // Navegação COM recarga (revisão de 08/10/2026): não sobra estado nem token em memória.
                        signOut();
                        window.location.replace(urlLogin());
                      }}
                    >
                      Sair
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </header>
        <div className="navbar navbar-light pt-0 mb-2">
          <div className="container-xl">
            <Navbar expand="lg" className="pl-0 pt-0">
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto navMenus">
                  {empresaTemRecursoN1 && temAcessoAbaN1 && havePermission([
                    "CadastroVidros",
                    "CadastroPerfis",
                    "CadastroComponentes",
                    "CadastroSuperficies",
                    "CadastroKits",
                    "ConsultaProduto",
                  ]) ? (
                    <div className="d-none"></div>
                  ) : (
                    // Reporte do PO de 31/08 (F05B-P3): o Home apontava para o /dashboard do MOF
                    // ANTIGO — clicar nele devolvia o usuário ao menu antigo, o oposto do pedido.
                    // Desde 23/09/2026 os cadastros gerais da Gerência também são do MOF novo.
                    <Link className="nav-link" to="/dashboardMof">
                      <i className="fas fa-home mr-1"></i> Home
                    </Link>
                  )}

                  {/* Sem Dashboard neste ambiente (Config.dashboardDisponivel), o item some do menu. */}
                  {dashboardDisponivel() && havePermission([
                    "DashboardSistemista",
                    "DashboardVidros",
                    "DashboardComponentesSuperficies",
                    "DashboardAcabamentos",
                  ]) && (
                    <Link className="nav-link" to="/dashboardMof" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '8px 16px' }}>
                      <i className="fas fa-chart-bar" style={{ fontSize: '18px', marginBottom: '4px' }}></i>
                      <span style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                        Dashboard <TagDashboard>BETA</TagDashboard>
                      </span>
                    </Link>
                  )}

                  {empresaTemRecursoTarefas && temAcessoAbaTarefas && havePermission([
                    "GerenciadorTarefas",
                    "Master",
                    "Configuracao",
                  ]) && (
                    <NavDropdown title={
                      <div style={menuItemStyle}>
                        <i className="fas fa-tasks" style={iconStyle}></i>
                        <span style={labelStyle}>Tarefas</span>
                      </div>
                    } id="tarefas-nav-dropdown">
                      <Link className="dropdown-link-color" to="/quadroTarefas">
                        <NavDropdown.Item as="span">
                          Quadro de tarefas
                        </NavDropdown.Item>
                      </Link>
                      <NavDropdown.Item
                        as="span"
                        className="dropdown-link-color"
                        style={{ cursor: "pointer" }}
                        onClick={() => setModalExportarTarefasOpen(true)}
                      >
                        Exportar Dados
                      </NavDropdown.Item>
                    </NavDropdown>
                  )}

                  {/* FASE 05 — 6ª validação/PO 2026-08-03: o menu Produtos passa a ter
                      um único destino (Produtos N1, tela nova) — vira link direto, sem
                      dropdown, com a chave de consulta ligada ou desligada. Os atalhos ao
                      sistema antigo (Perfil/Componente/Vidro/Superfície/Kit) e o menu
                      Acabamentos (que também apontava ao legado) foram removidos: o cadastro
                      N1 completo, incluindo Acabamentos, já vive dentro de Produtos N1. */}
                  {empresaTemRecursoN1 && temAcessoAbaN1 && havePermission([
                    "CadastroVidros",
                    "CadastroPerfis",
                    "CadastroComponentes",
                    "CadastroSuperficies",
                    "CadastroKits",
                    "ConsultaProduto",
                  ]) && (
                    <Link
                      className="nav-link"
                      to="/produtosN1"
                      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '8px 16px' }}
                    >
                      {navProdutos}
                    </Link>
                  )}
                  {/* FASE 05 — Ajustes 25/08 (item 1 / decisão F05A-P1 de 26/08): Acabamentos
                      volta ao menu — mas agora como PÁGINA NOVA do MOF (não o atalho ao legado
                      removido em 03/08). Aparece logo após "Produtos" e só quando a empresa tem
                      Acabamentos liberado em Gerência > Empresa > Cadastros N1 — a mesma chave
                      que o backend usa para devolver o tipo em ObterTiposPermitidos. */}
                  {empresaTemRecursoN1 && temAcessoAbaN1 && temAcabamentosLiberados && (
                    <Link
                      className="nav-link"
                      to="/acabamentosN1"
                      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '8px 16px' }}
                    >
                      {navAcabamentos}
                    </Link>
                  )}
                  {/* FASE 05 — S4-B2/PO 2026-05-13: acesso à tela de Tabelas de Preços (Materiais).
                      Plano 07/10/2026: recurso da empresa + aba do usuário + tela no token (não mais Exportacao/Configuracao/Master). */}
                  {acessoRecursos.tabelasPreco && (
                    <Link
                      className="nav-link"
                      to="/tabelas-precos"
                      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '8px 16px' }}
                    >
                      <i className="fas fa-tags" style={iconStyle}></i>
                      <span style={labelStyle}>Tabelas de Preços</span>
                    </Link>
                  )}
                  {empresaTemRecursoN2 && temAcessoAbaN2 && (acessoSolicitacoes || acessoCadastroTipologias) && (
                    <NavDropdown title={
                      <div style={menuItemStyle}>
                        <i className="fas fa-layer-group" style={iconStyle}></i>
                        <span style={labelStyle}>Tipologias</span>
                      </div>
                    } id="tipologias-nav-dropdown">
                      {acessoSolicitacoes && (
                        <Link className="dropdown-link-color" to="/solicitacoesMof">
                          <NavDropdown.Item as="span">
                            Solicitações
                          </NavDropdown.Item>
                        </Link>
                      )}
                      {acessoCadastroTipologias && (
                        <Link className="dropdown-link-color" to="/tipologiasMof">
                          <NavDropdown.Item as="span">
                            Consultas
                          </NavDropdown.Item>
                        </Link>
                      )}
                    </NavDropdown>
                  )}
                  {/* Plano 02/10/2026: menu "Ações" (Importar/Exportar) removido a pedido do PO —
                      as telas de importação de ZIP e exportação de pacotes saíram do MOF novo. */}
                  {havePermission(["Liberacao", "ConsultaLiberacao"]) && (
                    <NavDropdown title={navLiberacoes} id="liberacoes-nav-dropdown">
                      <Link
                        className="dropdown-link-color"
                        to="/liberacoesMof"
                      >
                        <NavDropdown.Item as="span">
                          Liberações CEM DELPHI
                        </NavDropdown.Item>
                      </Link>
                      <Link
                        className="dropdown-link-color"
                        to="/liberacoesMobi"
                      >
                        <NavDropdown.Item as="span">
                          Liberações CEM MOBI
                        </NavDropdown.Item>
                      </Link>
                      <Link
                        className="dropdown-link-color"
                        to="/liberacoesPadrao"
                      >
                        <NavDropdown.Item as="span">
                          Liberações Padrão
                        </NavDropdown.Item>
                      </Link>
                      <Link
                        className="dropdown-link-color"
                        to="/liberacoesDiversas"
                      >
                        <NavDropdown.Item as="span">
                          Liberações Diversas
                        </NavDropdown.Item>
                      </Link>
                    </NavDropdown>
                  )}
                  {/* Plano 07/10/2026: Aplicabilidades deixa de seguir a Gerência (Configuracao). */}
                  {acessoRecursos.aplicabilidades && (
                    <NavDropdown title={navAplicabilidades} id="aplicabilidades-nav-dropdown">
                      <Link
                        className="dropdown-link-color"
                        to="/aplicabilidades/consulta"
                      >
                        <NavDropdown.Item as="span">
                          Consulta
                        </NavDropdown.Item>
                      </Link>
                      <Link
                        className="dropdown-link-color"
                        to="/aplicabilidades/cadastros"
                      >
                        <NavDropdown.Item as="span">
                          Cadastro
                        </NavDropdown.Item>
                      </Link>
                    </NavDropdown>
                  )}
                  {havePermission(["Configuracao"]) && (
                    <NavDropdown title={
                      <div style={menuItemStyle}>
                        <i className="fas fa-building" style={iconStyle}></i>
                        <span style={labelStyle}>Gerência</span>
                      </div>
                    } id="basic-nav-dropdown">
                      <Link className="dropdown-link-color" to="/empresasMof">
                        <NavDropdown.Item as="span">Empresas</NavDropdown.Item>
                      </Link>

                      <Link
                        className="dropdown-link-color"
                        to="/perfisDeEmpresa"
                      >
                        <NavDropdown.Item as="span">
                          Perfis de Empresa
                        </NavDropdown.Item>
                      </Link>

                      <Link
                        className="dropdown-link-color"
                        to="/projetistas"
                      >
                        <NavDropdown.Item as="span">
                          Projetistas
                        </NavDropdown.Item>
                      </Link>

                      {havePermission(["Liberacao", "ConsultaLiberacao"]) && (
                        <Link
                          className="dropdown-link-color"
                          to="/notificacoesMof"
                        >
                          <NavDropdown.Item as="span">
                            Notificações
                          </NavDropdown.Item>
                        </Link>
                      )}

                      {/* FASE 05 — Cadastros Gerais (plano de 23/09/2026): os cadastros da Gerência saíram do
                          MOF antigo. Ordem do menu legado. Plano 02/10/2026 (Frente 4): Catálogos passa a
                          exigir a tela Configuracao, como os demais itens de Gerência — ninguém tinha
                          CadastroEsquadrias/CadastroCatalogos e o item sumia para todos. */}
                      {havePermission(["Configuracao"]) && (
                        <Link className="dropdown-link-color" to="/cadastros/catalogos">
                          <NavDropdown.Item as="span">Catálogos</NavDropdown.Item>
                        </Link>
                      )}

                      <Link className="dropdown-link-color" to="/cadastros/classes-ids">
                        <NavDropdown.Item as="span">Classes / ID</NavDropdown.Item>
                      </Link>

                      <Link className="dropdown-link-color" to="/cadastros/cores">
                        <NavDropdown.Item as="span">Cores</NavDropdown.Item>
                      </Link>

                      <Link className="dropdown-link-color" to="/cadastros/tipos-acabamento">
                        <NavDropdown.Item as="span">Tipos de Acabamento</NavDropdown.Item>
                      </Link>

                      <Link className="dropdown-link-color" to="/cadastros/grupos">
                        <NavDropdown.Item as="span">Grupos</NavDropdown.Item>
                      </Link>

                      <Link className="dropdown-link-color" to="/cadastros/tipos-vidro">
                        <NavDropdown.Item as="span">Tipos de Vidro</NavDropdown.Item>
                      </Link>

                      <Link className="dropdown-link-color" to="/configuracoes/tecidos">
                        <NavDropdown.Item as="span">Tipos de Tecido</NavDropdown.Item>
                      </Link>

                      <Link className="dropdown-link-color" to="/cadastros/unidades">
                        <NavDropdown.Item as="span">Unidades</NavDropdown.Item>
                      </Link>

                      <Link className="dropdown-link-color" to="/cadastros/referencias">
                        <NavDropdown.Item as="span">Referências</NavDropdown.Item>
                      </Link>

                      {/* FASE 05 (17/08/2026): o Cadastro de Linhas passou a ser do MOF novo. */}
                      <Link className="dropdown-link-color" to="/linhas">
                        <NavDropdown.Item as="span">Linhas</NavDropdown.Item>
                      </Link>

                      <Link className="dropdown-link-color" to="/cadastros/prenativos">
                        <NavDropdown.Item as="span">Prenativo</NavDropdown.Item>
                      </Link>

                      <Link className="dropdown-link-color" to="/cadastros/ligas">
                        <NavDropdown.Item as="span">Ligas / Temperas</NavDropdown.Item>
                      </Link>
                      <Link
                        className="dropdown-link-color"
                        to="/tiposAtividade"
                      >
                        <NavDropdown.Item as="span">
                          Tipos de Atividade
                        </NavDropdown.Item>
                      </Link>
                    </NavDropdown>
                  )}
                  {/* Desenhador removido do menu (decisão L4 de 07/10/2026: não é mais utilizado). */}
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>

        <Grid container display={"flex"} justifyContent={"center"}>
          <AcessoRecursosContext.Provider value={acessoRecursos}>
            {children}
          </AcessoRecursosContext.Provider>
        </Grid>

        {/* Modal Exportar Dados (menu Tarefas) */}
        <ModalExportarDados
          open={modalExportarTarefasOpen}
          onClose={() => setModalExportarTarefasOpen(false)}
        />

        <footer className="footer footer-transparent d-print-none">
          <div className="container">
            <div className="row no-gutters">
              <div className="col-6 text-left">
                <ul className="list-inline list-inline-dots ml-0 mb-0">
                  <li className="list-inline-item">
                    <a href="#" className="link-secondary">
                      TERMOS DE USO
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-6 text-right">
                <ul className="list-inline list-inline-dots mb-0">
                  <li className="list-inline-item">
                    <span className="copyright">
                      © {new Date().getFullYear()} - Desenvolvido por{" "}
                      <a href="http://www.alumisoft.com.br/" target="blank">
                        {" "}
                        Alumisoft Sistemas
                      </a>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </>
    </SidebarProvider>
  );
};
